import React from 'react';
import { FileSpreadsheet, RotateCcw, Search } from 'lucide-react';
import { Button } from '../../Button';
import { NativeSelect } from '../../common/NativeSelect';
import { Panel } from '../../common/Panel';
import { trafficDivisions, validationOfficers } from '../../../data/applicationReview';
import { queueMeta } from '../../../utils/applicationQueue';
import { ALL } from '../../../hooks/useApplicationList';
import type { AppFilter } from '../../../hooks/useApplicationList';
interface Props {
  draft: AppFilter;
  setDraft: (f: AppFilter) => void;
  onSearch: () => void;
  onReset: () => void;
  onExport: () => void;
}
const textFields: {
  key: keyof AppFilter;
  label: string;
  placeholder: string;
}[] = [{
  key: 'appNo',
  label: 'আবেদন নম্বর',
  placeholder: 'DMP-OWN-2026-…'
}, {
  key: 'reg',
  label: 'গাড়ির রেজিস্ট্রেশন নম্বর',
  placeholder: 'ঢাকা-থ-১১-১২৩৪'
}, {
  key: 'owner',
  label: 'মালিকের নাম',
  placeholder: 'নাম লিখুন'
}, {
  key: 'mobile',
  label: 'মোবাইল নম্বর',
  placeholder: '০১৭…'
}, {
  key: 'nid',
  label: 'NID নম্বর',
  placeholder: '১৯৮…'
}, {
  key: 'date',
  label: 'আবেদনের তারিখ',
  placeholder: 'দিন/মাস/বছর'
}];
export function ApplicationFilters({
  draft,
  setDraft,
  onSearch,
  onReset,
  onExport
}: Props) {
  const set = (k: keyof AppFilter, v: string) => setDraft({
    ...draft,
    [k]: v
  });
  const statuses = [ALL, ...Object.values(queueMeta).map(m => m.label)];
  return <Panel title="অনুসন্ধান ও ফিল্টার" className="mb-4" bodyClassName="p-4" actions={<>
          <Button variant="outline" size="sm" onClick={onReset} data-id="element-153" data-mp="uyqtzzvr496r"><RotateCcw className="h-3.5 w-3.5" data-id="element-154" data-mp="g28gg806hd4h" />ফিল্টার রিসেট</Button>
          <Button variant="outline" size="sm" onClick={onExport} data-id="element-155" data-mp="g42qgr9wvkts"><FileSpreadsheet className="h-3.5 w-3.5 text-emerald-700" data-id="element-156" data-mp="l09xkne1n2db" />Excel Export</Button>
          <Button size="sm" onClick={onSearch} data-id="element-157" data-mp="30rxval0vsyx6"><Search className="h-3.5 w-3.5" data-id="element-158" data-mp="30qnwtuq49oq0" />অনুসন্ধান</Button>
        </>} data-id="element-152" data-mp="pzwcd19isqo8">
      <form className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5" onSubmit={e => {
      e.preventDefault();
      onSearch();
    }} data-id="element-159" data-mp="35s3gpjgk5p6t">
        {textFields.map(f => <div key={f.key} data-id="element-160" data-mp="17a0aq6mnq32f">
            <label htmlFor={`af-${f.key}`} className="mb-1 block text-xs font-medium text-slate-600" data-id="element-161" data-mp="17bujynokg6qo">{f.label}</label>
            <input id={`af-${f.key}`} value={draft[f.key]} placeholder={f.placeholder} onChange={e => set(f.key, e.target.value)} className="h-9 w-full rounded-md border border-input bg-white px-3 text-sm text-navy-900 outline-none placeholder:text-slate-300 focus:border-navy-500 focus:ring-2 focus:ring-navy-100" data-id="element-162" data-mp="xjylhbikielx" />
          </div>)}
        <NativeSelect id="af-type" label="গাড়ির ধরন" options={[ALL, 'সিএনজি', 'মোটরসাইকেল']} value={draft.type} onChange={e => set('type', e.target.value)} data-id="element-163" data-mp="elmd3rzhd8re" />
        <NativeSelect id="af-status" label="আবেদন অবস্থা" options={statuses} value={draft.status} onChange={e => set('status', e.target.value)} data-id="element-164" data-mp="2dvkmu3niy9wv" />
        <NativeSelect id="af-div" label="সংশ্লিষ্ট ট্রাফিক বিভাগ" options={[ALL, ...trafficDivisions]} value={draft.division} onChange={e => set('division', e.target.value)} data-id="element-165" data-mp="2ghbkjyqmpfa8" />
        <NativeSelect id="af-off" label="দায়িত্বপ্রাপ্ত কর্মকর্তা" options={[ALL, ...validationOfficers]} value={draft.officer} onChange={e => set('officer', e.target.value)} data-id="element-166" data-mp="2q7muc1wzuip1" />
        <button type="submit" className="sr-only" data-id="element-167" data-mp="1xjin3byrxxk8">অনুসন্ধান</button>
      </form>
    </Panel>;
}